import { SkeletonFrame, SkeletonType } from '@nextgen-web-framework/all';
import styles from './SkeletonLoader.module.scss';

// eslint-disable-next-line
export default function SkeletonLoader() {
  const heightValue = '24';

  return (
    <>
      <div className={styles['skeleton-loader-card']} data-testid="skeleton-loader-card">
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
      </div>
      <div className={styles['skeleton-loader-card']}>
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
        <SkeletonFrame type={SkeletonType.FULL_WIDTH} heightValue={heightValue} />
      </div>
    </>
  );
}
